/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportsdescription2Inputs */

const en_contentreportsdescription2 = /** @type {(inputs: Contentreportsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User-submitted reports about listings and events`)
};

const de_contentreportsdescription2 = /** @type {(inputs: Contentreportsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldungen zu Orten und Events`)
};

/**
* | output |
* | --- |
* | "User-submitted reports about listings and events" |
*
* @param {Contentreportsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportsdescription2 = /** @type {((inputs?: Contentreportsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportsdescription2(inputs)
	return de_contentreportsdescription2(inputs)
});
export { contentreportsdescription2 as "contentReportsDescription" }